// extracted by mini-css-extract-plugin
export default {"cal-head":"CalendarMonth_cal-head__Rlef8","cal-body":"CalendarMonth_cal-body__V4-eD"};